import { render, staticRenderFns } from "./files_company.vue?vue&type=template&id=0d415ed0&scoped=true"
import script from "./files_company.vue?vue&type=script&lang=js"
export * from "./files_company.vue?vue&type=script&lang=js"
import style0 from "./files_company.vue?vue&type=style&index=0&id=0d415ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d415ed0",
  null
  
)

export default component.exports